import { ShoppingCartOutlined } from '@mui/icons-material';
import ImageOutlined from '@mui/icons-material/ImageOutlined';
import { ApprovalDelegationIcon } from 'images/icons/ApprovalDelegationIcon';
import { DeleteIcon } from 'images/icons/DeleteIcon';
import React from 'react';
import { DATA_MANAGEMENT_BLUE } from 'utilities/colors';

const toTitleCase = (phrase) =>
  phrase
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
export const ALL_BLOCKS = 'all';
export const ACTIVE_BLOCKS = 'active';
export const DISPOSED_BLOCKS = 'disposed';
export const CONTRIBUTED_BLOCKS = 'contributed';

export const columnDefs = [
  {
    field: 'block.orderName',
    headerName: 'ORDER ID',
    filter: true,
    sortable: false,
    tooltipField: 'block.orderName',
  },
  {
    field: 'slidesCount',
    headerName: 'SLIDES',
    width: 120,
    filter: true,
    sortable: false,
  },
  {
    field: 'state',
    headerName: 'State',
    valueGetter: ({ data }) => data?.state && toTitleCase(data.state),
    filter: true,
    sortable: false,
  },
  {
    field: 'atHistowiz',
    headerName: 'AT HISTOWIZ',
    headerTooltip: 'Block at HistoWiz',
    valueGetter: ({ data }) => data && (data.atHistowiz ? 'Yes' : 'No'),
    filter: true,
    sortable: false,
  },
  {
    field: 'submission',
    headerName: 'SUBMISSION TYPE',
    headerTooltip: 'Submission type',
    filter: true,
    sortable: false,
    tooltipField: 'submission',
  },
  {
    field: 'organ',
    headerName: 'ORGAN',
    headerTooltip: 'Organ',
    filter: true,
    sortable: false,
  },
  {
    field: 'species',
    headerName: 'SPECIES',
    headerTooltip: 'Species',
    filter: true,
    sortable: false,
    tooltipField: 'species',
  },
  {
    field: 'tumorType',
    headerName: 'TUMOR TYPE',
    headerTooltip: 'Tumor type',
    filter: true,
    sortable: false,
  },
  {
    field: 'controlType',
    headerName: 'CONTROL TYPE',
    headerTooltip: 'Control type',
    filter: true,
    sortable: false,
  },
  {
    field: 'created',
    headerName: 'SUBMISSION DATE',
    headerTooltip: 'Submission date',
    filter: true,
  },
  {
    field: 'modified',
    headerName: 'LAST MODIFIED',
    headerTooltip: 'Last modified',
    filter: true,
    sortable: true,
    sort: 'desc',
  },
];

export const defaultColDef = {
  flex: 1,
  minWidth: 110,
  filter: true,
  sort: 'asc',
  sortable: true,
};

export const toolTipValueGetterForGrouped = (params) => {
  const count = params.node && params.node.allChildrenCount;

  if (count != null) {
    return `${params.value} (${count})`;
  }

  return params.value;
};

export const autoGroupColumnDef = {
  headerName: 'PROJECT/BLOCK',
  minWidth: 240,
  showDisabledCheckboxes: true,
  cellRendererParams: {
    suppressCount: true,
    checkbox: true,
  },
  tooltipValueGetter: toolTipValueGetterForGrouped,
};

export const SLIDES_SECTION_TITLE = 'SLIDES CREATED FROM BLOCK:';

export const blockActions = {
  imageData: 'Image data',
  processingQueue: 'Processing queue',
};

export const blockActionsIcons = {
  imageData: <ImageOutlined />,
  processingQueue: <ShoppingCartOutlined />,
};

const CONTRIBUTE = 'contribute';
const DISPOSE = 'dispose';
const SHIP_BACK = 'ship back';

export const SubmitBlocksTypes = {
  CONTRIBUTE,
  DISPOSE,
  SHIP_BACK,
};

export const selectBlockActionOptions = (selectedOption) => [
  {
    value: DISPOSE,
    label: 'Dispose',
    icon: (
      <DeleteIcon
        color={
          selectedOption?.value === 'delete' ? DATA_MANAGEMENT_BLUE : 'black'
        }
      />
    ),
  },
  {
    value: CONTRIBUTE,
    label: 'Contribute',
    icon: (
      <ApprovalDelegationIcon
        color={
          selectedOption?.value === 'contribute'
            ? DATA_MANAGEMENT_BLUE
            : 'black'
        }
      />
    ),
  },
  /* {
    value: SHIP_BACK,
    label: 'Ship Back',
    icon: (
      <HardDriveIcon
        color={
          selectedOption?.value === 'export' ? DATA_MANAGEMENT_BLUE : 'black'
        }
      />
    ),
  }, */
];

export const changeLogHeaders = [
  { xs: 0.75, value: 'DATE' },
  { xs: 1.25, value: 'ACTION PERFORMED' },
  { xs: 1.5, value: 'ORDERED BY' },
  { xs: 2.25, value: 'PROJECT/BLOCK' },
  { xs: 0.75, value: 'ORDER ID' },
  { xs: 2, value: 'SUBMISSION' },
  { xs: 0.75, value: 'ORGAN' },
  { xs: 0.75, value: 'SPECIES' },
  { xs: 0.75, value: 'TUMOR' },
  { xs: 1, value: 'CONTROL TYPE' },
];

export const changeLogTypes = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
};

export const blocksPendingActionStatuses = {
  CUSTOMER_REQUESTED_DISPOSAL: 'customer_requested_disposal',
  CUSTOMER_REQUESTED_CONTRIBUTION: 'customer_requested_contribution',
  PENDING_DISPOSAL: 'pending_disposal',
  WAITING_FOR_CUSTOMER_CONTRIBUTION_DATA:
    'waiting_for_customer_contribution_data',
  CONTRIBUTION_METADATA_RECEIVED: 'contribution_metadata_received',
  CONTRIBUTION_METADATA_UNDER_REVIEW: 'contribution_metadata_under_review',
  CONTRIBUTION_PROPOSAL_SENT: 'contribution_proposal_sent',
  CONTRIBUTION_PROPOSAL_ACCEPTED: 'contribution_proposal_accepted',
  CONTRIBUTION_PROPOSAL_REJECTED: 'contribution_proposal_rejected',
};

export const blocksCompletedActionStatuses = {
  DISPOSED: 'disposed',
  CONTRIBUTION_APPROVED: 'contribution_approved',
};

export const blocksAfterActionStatuses = {
  ...blocksCompletedActionStatuses,
  ...blocksPendingActionStatuses,
};

export const contributedBlocksStatuses = {
  CUSTOMER_REQUESTED_CONTRIBUTION: 'customer_requested_contribution',
  WAITING_FOR_CUSTOMER_CONTRIBUTION_DATA:
    'waiting_for_customer_contribution_data',
  CONTRIBUTION_METADATA_RECEIVED: 'contribution_metadata_received',
  CONTRIBUTION_METADATA_UNDER_REVIEW: 'contribution_metadata_under_review',
  CONTRIBUTION_PROPOSAL_SENT: 'contribution_proposal_sent',
  CONTRIBUTION_PROPOSAL_ACCEPTED: 'contribution_proposal_accepted',
  CONTRIBUTION_PROPOSAL_REJECTED: 'contribution_proposal_rejected',
};

export const disposedBlocksStatuses = {
  CUSTOMER_REQUESTED_DISPOSAL: 'customer_requested_disposal',
  PENDING_DISPOSAL: 'pending_disposal',
  DISPOSED: 'disposed',
};

export const blocksStatuses = {
  NEW: 'new',
  LOST: 'lost',
  CHECKED_OUT_FROM_DREAMPATH: 'checked_out_from_dreampath',
  RETURNED: 'returned',
  HOLDING: 'holding',
  IN_PROGRESS: 'in_progress',
  IN_HISTOLOGY: 'in_histology',
  PENDING: 'pending',
  QC_ISSUE: 'qc_issue',
  CONTRIBUTION_CANCELLED: 'contribution_cancelled',
  ...blocksAfterActionStatuses,
};
